import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "Обучение",
  "lead": "По меньшей мере в 15 странах Африки к югу от Сахары более половины учащихся не достигают минимального уровня владения чтением к моменту окончания начальной школы."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Figure, HighlightByIndex, IndicatorReference, RelatedMaterial, ScrollyArea, ScrollySection, ScrollySticky} = _components;
  if (!Figure) _missingMdxReference("Figure", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_LEARNING"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "Посещение школы недостаточно. Не снижая значимости многих других важных реализуемых и поставленных школой целей, учащиеся должны овладеть навыками чтения и математики. Они являются основой для дальнейшего обучения, для личностного развития и благополучия, а также для достижения социальных, политических и экономических результатов."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "дети-и-молодежь",
      children: "Дети и молодежь"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.1",
      label: "4.1.1a",
      children: [_jsxs(_components.p, {
        children: ["Многие дети в некоторых беднейших странах мира не владеют базовыми навыками чтения и математики.\nОценка навыков чтения учеников начальных классов в северных штатах Нигерии, таких как Кадуна и Сокото, и в провинциях Демократической Республики Конго, таких как Экваториальная провинция и Катанга, например, показывают, что более 80 % учеников 3 класса в начальной школе не могут прочитать ", _jsx(_components.strong, {
          children: "ни одного слова"
        }), " связного текста."]
      }), _jsx(Figure, {
        id: "EGRA"
      })]
    }), "\n", _jsx(_components.p, {
      children: "Эти данные не охватывают детей, не посещающих школу. Опросы членов домашних хозяйств могут определить навыки как посещающих, так и не посещающих школу детей."
    }), "\n", _jsx(_components.p, {
      children: "Например, на графиках ниже показаны различные регионы Пакистана и сельской Индии, основанные на оценках, проводимых гражданами."
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(HighlightByIndex, {
        index: "1",
        children: "Красными линиями"
      }), " показан процент детей, ", _jsx(_components.strong, {
        children: "посещающих школу"
      }), ", и имеющих базовые навыки чтения, в разбивке по классам, а ", _jsx(HighlightByIndex, {
        index: "0",
        children: "синими линиями"
      }), " показан процент всех детей, которые имеют базовые навыки чтения, ", _jsx(_components.strong, {
        children: "независимо от того, посещают они школу или нет, в разбивке по возрасту, соответствующему их классу"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "Разрывы между двумя линиями напоминают о том, что в странах с высоким уровнем непосещения школы лица, ответственные за разработку политики, получают лишь частичную картину, если отслеживают только успеваемость в школе. Важно отметить, что отслеживаемый уровень навыка очень низкий. Даже в регионах с наилучшими показателями по крайней мере небольшая доля подростков в средней школе не может прочитать текст для второго класса."
    }), "\n", _jsx(Figure, {
      id: "LEARN_AGE_GRADE"
    }), "\n", _jsx(IndicatorReference, {
      id: "4.1.1",
      label: "4.1.1b",
      children: _jsx(_components.p, {
        children: "Согласно оценкам, около 40 % детей младшего школьного возраста не имеют базовых навыков чтения. Это касается 70 % детей в странах Африки к югу от Сахары и только 3 % детей в Европе и Северной Америке."
      })
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.0",
      label: "4.1.0",
      children: [_jsx(_components.p, {
        children: "Во многих странах нет гарантии, что дети будут уметь читать, даже если они окончили начальную школу. Во всем мире среди тех, кто окончил начальную школу, четверо из десяти не обладают базовыми навыками чтения. Как видно из приведенного ниже графика, в странах с низким уровнем дохода этот показатель возрастает до 8 из 10."
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "LEARN_REACHFINAL"
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: [_jsx(HighlightByIndex, {
              index: "-1",
              children: "Серым цветом "
            }), " показан процент детей, которые окончили начальную школу, но не достигли минимального уровня владения навыками чтения. ", _jsx(HighlightByIndex, {
              index: "1",
              children: "Красным цветом"
            }), " показаны те учащиеся, которые окончили начальную школу и достигли минимального уровня владения навыками, а ", _jsx(HighlightByIndex, {
              index: "0",
              children: "синим цветом"
            }), " показаны те дети, которые не завершили начальное образование."]
          })
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: "Если рассматривать ситуацию на уровне страны, то в Чаде и Нигерии около 90 % молодых людей, прекративших посещение школы после 5 или 6 лет обучения, не были грамотными. Однако некоторые страны имеют гораздо лучшие показатели. Например, в Бурунди, Коста-Рике и Гондурасе почти все, кто бросил школу после 5-го или 6-го класса, были грамотными."
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "LITBYYRS"
        })
      }), _jsx(ScrollySection, {
        id: "KEN",
        children: _jsxs(_components.p, {
          children: ["В ", _jsx(_components.strong, {
            children: "Кении"
          }), ", например, грамотным является каждый четвертый ребенок, имеющий ", _jsx(HighlightByIndex, {
            index: "1",
            children: "до 4 лет школьного образования"
          }), ", но этот показатель увеличивается до трех из четырех детей среди тех, кто имеет ", _jsx(HighlightByIndex, {
            index: "0",
            children: "5–6 лет школьного образования"
          }), " — эквивалент начального образования."]
        })
      }), _jsx(ScrollySection, {
        id: "BFA",
        children: _jsxs(_components.p, {
          children: ["В ", _jsx(_components.strong, {
            children: "Буркина-Фасо"
          }), " почти ни один ребенок ", _jsx(HighlightByIndex, {
            index: "1",
            children: "после 4 лет обучения"
          }), " не умеет читать, но более половины владеют базовыми навыками грамотности, если они проходят ", _jsx(HighlightByIndex, {
            index: "0",
            children: "полный курс начального образования"
          }), "."]
        })
      })]
    }), "\n", _jsx(_components.p, {
      children: "Оценки и тесты, соответствующие международным стандартам и имеющие одно общее определение, позволят сравнивать обучение в разных странах. Такие стандарты недавно были введены для оценки данных по странам, когда учащиеся разных стран сдают один и тот же тест. Однако на сегодняшний день существует лишь ограниченное число таких сопоставительных данных для национальных оценок."
    }), "\n", _jsx(_components.p, {
      children: "Одна из таких оценок, Исследование международных тенденций в области изучения математических и естественно-научных дисциплин (ТИМСС), проводится каждые четыре года и позволяет нам отслеживать прогресс учащихся 4-х и 8-х классов с течением времени. Исследование показывает, где прогресс был особенно медленным. Например, в Египте процент учащихся 8-го класса, достигших минимального уровня знаний по математике, увеличился с 24 % в 2003 году до всего лишь 27 % в 2019 году."
    }), "\n", _jsxs(_components.p, {
      children: ["А в некоторых странах, таких как ", _jsx(HighlightByIndex, {
        index: "0",
        children: "Малайзия"
      }), ", даже доля учащихся, достигших минимального уровня образования, со временем снижается."]
    }), "\n", _jsxs(_components.p, {
      children: ["В других странах, таких как ", _jsx(HighlightByIndex, {
        index: "1",
        children: "Бахрейн"
      }), ", прогресс был быстрым — доля учащихся с минимальным уровнем владения навыками более чем утроилась в период с 2003 по 2019 год."]
    }), "\n", _jsx(Figure, {
      id: "PIRLSGAIN"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.1",
      label: "4.1.1b",
      children: [_jsx(_components.p, {
        children: "Вопреки ожиданиям большинства людей, гендерный разрыв в обучении невелик — например, в начальном образовании почти во всех странах он не превышает десяти процентных пунктов."
      }), _jsx(_components.p, {
        children: "Однако разрыв в обучении между странами огромен. В странах Африки к югу от Сахары, где навыки чтения в начальной школе, как правило, находятся на самом низком уровне, доля учащихся, достигших минимального уровня владения навыками, находится в диапазоне 4 % в Бурунди и 76 % в Габоне (оба результата взяты из PASEC (Программа анализа систем обучения) 2019 года)."
      }), _jsx(_components.p, {
        children: "В странах Юго-Восточной Азии показатели по математике в начальной школе варьируются от 8 % в Лаосской Народно-Демократической Республике до 91 % во Вьетнаме (оба результата взяты из SEA–PLM (Оценка эффективности обучения в начальных школах стран Юго-Восточной Азии), данные за 2019 год)."
      }), _jsx(Figure, {
        id: "ASSESS"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "взрослые",
      children: "Взрослые"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.6.2",
      children: [_jsx(_components.p, {
        children: "В период с 2000 по 2023 год процент грамотных взрослых увеличился с 81 % до 87 % во всем мире, в то время как процент грамотной молодежи увеличился с 87 % до 93 %."
      }), _jsx(_components.p, {
        children: "Несмотря на эти улучшения, во многих странах по-прежнему широко распространена неграмотность, особенно среди женщин. В Латинской Америке и странах Карибского бассейна замедление прогресса на относительно высоких уровнях отражает наличие «труднодоступных» групп, находящихся в крайне неблагоприятном положении. В Эквадоре, например, уровень грамотности среди взрослых женщин в сельской местности за последние 10 лет практически не изменился и составляет около 83 %."
      }), _jsx(_components.p, {
        children: "В странах Африки к югу от Сахары более 40 % взрослых женщин (25–64 лет) не умеют читать. Во многих странах прогресс остановился на очень низком уровне, как например, в Мали, где менее 17 % взрослых женщин умеют читать, или замедлился, как например, в Объединенной Республике Танзания, где за десять лет этот показатель улучшился лишь с 72 % до 77 %."
      }), _jsx(_components.p, {
        children: "Если в глобальном масштабе сегодня больше грамотных взрослых, чем раньше, то это происходит в основном потому, что больше взрослых ходили в школу в молодости, а не потому, что у взрослых, которые не ходили в школу, был второй шанс учиться. Для проверки этого утверждения представленный ниже график показывает данные о развитии навыков грамотности в определенной когорте (или группе) с течением времени."
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "LITCOHORT"
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["В большинстве стран уровень грамотности среди определенной ", _jsx(HighlightByIndex, {
              index: "0",
              children: "когорты взрослых"
            }), " оставался на прежнем уровне или даже снижался, поскольку навыки не использовались в полной мере."]
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["В ", _jsx(_components.strong, {
              children: "Буркина-Фасо"
            }), " синяя линия показывает, что уровень грамотности ", _jsx(HighlightByIndex, {
              index: "0",
              children: "женщин в возрасте 20–34 лет в 2003 году"
            }), ", ", _jsx(HighlightByIndex, {
              index: "0",
              children: "27–41 года в 2010 году"
            }), " и ", _jsx(HighlightByIndex, {
              index: "0",
              children: "38–62 лет в 2021 году"
            }), " оставался относительно стабильным. И все же, поскольку все больше молодых женщин становятся грамотными, красная линия показывает, что ", _jsx(HighlightByIndex, {
              index: "1",
              children: "уровень грамотности среди женщин в возрасте 20–34 лет"
            }), " растет с течением времени."]
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.6.1",
      children: [_jsx(_components.p, {
        children: "Навыки грамотности, которые измеряются в ходе этих оценок, являются весьма базовыми. Они показывают, способны ли люди прочитать простое предложение. Функциональная грамотность, при которой люди могут читать и понимать письменные инструкции, официальные письма или контракты, — это совсем другое дело."
      }), _jsx(_components.p, {
        children: "Лишь немногие международные исследования собирают данные о функциональной грамотности, и еще реже — на регулярной основе."
      }), _jsx(_components.p, {
        children: "Из имеющихся у нас данных следует, что более 1 из 10 взрослых городских жителей в Колумбии и Вьетнаме, и 1 из 4 в Боливии не обладают функциональной грамотностью (т. е. не достигли уровня 1 по уровню владения навыками)."
      }), _jsxs(_components.p, {
        children: ["В ", _jsx(_components.strong, {
          children: "Гане"
        }), " даже среди взрослых городских жителей лишь 39 % обладают навыками функциональной грамотности."]
      }), _jsx(Figure, {
        id: "LITPROF"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "заключение",
      children: "Заключение"
    }), "\n", _jsx(_components.p, {
      children: "Несмотря на то, что ЦУР 4 сместила акцент на мониторинг обучения, многие страны все еще не отчитываются о показателях результатов обучения чтению и математике. Даже страны, которые хотят начать оценку и отчетность по обучению, часто сталкиваются с препятствиями, не позволяющими им принять эффективные и экономически выгодные решения. Однако имеющиеся у нас данные свидетельствуют о том, что большинство учащихся в беднейших странах мира не достигают минимального уровня владения даже самыми базовыми навыками."
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://openknowledge.worldbank.org/handle/10986/32553",
            children: "Покончить с бедностью в плане обучения — что для этого потребуется? — Всемирный банк"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "http://uis.unesco.org/sites/default/files/documents/ip61-combining-data-out-of-school-children-completion-learning-offer-more-comprehensive-view-sdg4.pdf",
            children: "Объединение данных о детях, не посещающих школу, получении образования и обучении с целью получения более полного представления о ЦУР 4 — СИЮ"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://unesdoc.unesco.org/ark:/48223/pf0000225660",
            children: "Всемирный доклад по мониторингу ОДВ 2013/4: Преподавание и обучение: обеспечение качества для всех"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://gemreportunesco.wordpress.com/2019/05/20/the-learning-assessment-market-pointers-for-countries-part-2/",
            children: "Рынок оценки обучения — ориентиры для стран"
          })
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
